__turbopack_context__.v({
  "body": "CenterCallout-module-scss-module__jz86Xa__body",
  "centerCallout": "CenterCallout-module-scss-module__jz86Xa__centerCallout",
  "contentCard": "CenterCallout-module-scss-module__jz86Xa__contentCard",
  "eyebrow": "CenterCallout-module-scss-module__jz86Xa__eyebrow",
  "headline": "CenterCallout-module-scss-module__jz86Xa__headline",
  "media": "CenterCallout-module-scss-module__jz86Xa__media",
  "mediaWrapper": "CenterCallout-module-scss-module__jz86Xa__mediaWrapper",
  "overlay": "CenterCallout-module-scss-module__jz86Xa__overlay",
  "stack-module-0": "CenterCallout-module-scss-module__jz86Xa__stack-module-0",
  "stack-module-1": "CenterCallout-module-scss-module__jz86Xa__stack-module-1",
  "stack-module-10": "CenterCallout-module-scss-module__jz86Xa__stack-module-10",
  "stack-module-11": "CenterCallout-module-scss-module__jz86Xa__stack-module-11",
  "stack-module-12": "CenterCallout-module-scss-module__jz86Xa__stack-module-12",
  "stack-module-13": "CenterCallout-module-scss-module__jz86Xa__stack-module-13",
  "stack-module-14": "CenterCallout-module-scss-module__jz86Xa__stack-module-14",
  "stack-module-15": "CenterCallout-module-scss-module__jz86Xa__stack-module-15",
  "stack-module-16": "CenterCallout-module-scss-module__jz86Xa__stack-module-16",
  "stack-module-17": "CenterCallout-module-scss-module__jz86Xa__stack-module-17",
  "stack-module-18": "CenterCallout-module-scss-module__jz86Xa__stack-module-18",
  "stack-module-19": "CenterCallout-module-scss-module__jz86Xa__stack-module-19",
  "stack-module-2": "CenterCallout-module-scss-module__jz86Xa__stack-module-2",
  "stack-module-20": "CenterCallout-module-scss-module__jz86Xa__stack-module-20",
  "stack-module-3": "CenterCallout-module-scss-module__jz86Xa__stack-module-3",
  "stack-module-4": "CenterCallout-module-scss-module__jz86Xa__stack-module-4",
  "stack-module-5": "CenterCallout-module-scss-module__jz86Xa__stack-module-5",
  "stack-module-6": "CenterCallout-module-scss-module__jz86Xa__stack-module-6",
  "stack-module-7": "CenterCallout-module-scss-module__jz86Xa__stack-module-7",
  "stack-module-8": "CenterCallout-module-scss-module__jz86Xa__stack-module-8",
  "stack-module-9": "CenterCallout-module-scss-module__jz86Xa__stack-module-9",
  "video": "CenterCallout-module-scss-module__jz86Xa__video",
  "z-base": "CenterCallout-module-scss-module__jz86Xa__z-base",
  "z-content": "CenterCallout-module-scss-module__jz86Xa__z-content",
  "z-footer": "CenterCallout-module-scss-module__jz86Xa__z-footer",
  "z-header": "CenterCallout-module-scss-module__jz86Xa__z-header",
  "z-hero": "CenterCallout-module-scss-module__jz86Xa__z-hero",
  "z-logo": "CenterCallout-module-scss-module__jz86Xa__z-logo",
  "z-logo-effect": "CenterCallout-module-scss-module__jz86Xa__z-logo-effect",
  "z-navigation": "CenterCallout-module-scss-module__jz86Xa__z-navigation",
  "z-sub": "CenterCallout-module-scss-module__jz86Xa__z-sub",
});
